//CustomPopover_clickSelect


export function CustomPopover_clickSelect() {

    //close the window if they navigate away from it for more then 3 seconds, keep open when they hover over the selection menu, untill they leave.
    let templateEngine = new ko.nativeTemplateEngine();
    let timer = 0;
    var debounce = ( function () {
        
        return function (callback, ms) {
            clearTimeout(timer);
            timer = setTimeout(callback, ms);
        };
    })();
    var cancelTimeout = (function () { clearTimeout(timer); })

    ko.bindingHandlers.CustomPopover_clickSelect = {
        init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            var placement = allBindings.get("placement") || "top",                
                templateName = allBindings.get("CustomPopover_clickSelect") || null,
                $element = $(element);

            let template = '<div class="popover px-1" role="tooltip" style="width: 500px;">';
            template += '<div class="arrow"></div><h3 class="popover-title"></h3>';
            template += '<div class="popover-content mx-1"><div class="data-content"></div></div></div>';

            $element.popover({
                placement: placement,                
                html: true,
                content: "&nbsp;",
                template: template
            }).on('mouseout', function (ev) {
                //console.log("Mouseout..");
                debounce(function () {
                    //console.log("mouse out timeout hide..");
                    $(".popover").popover("hide");
                }, 3000);
            })
                .on('mouseenter', function (ev) {
                    console.log("Mouse enter..");
                    $(".popover").popover("hide");
                    
                })
            //    .on('mouseover', function (ev)
            //{
            //    console.log("MouseOver....");
            //    //WAS THIS $(".popover").popover("hide");                
            //})                
                .on('click', function (ev) {
                    //console.log("CLICKED OPEN", "the current active pop over=", $element.attr("aria-describedby"))
                    //console.log("hovering id name.....", "#" + $element.attr("aria-describedby") , "_____" )
                    $("#" + $element.attr("aria-describedby")).off('mouseenter')                    
                    $("#" + $element.attr("aria-describedby")).on('mouseenter', function () {                        
                        cancelTimeout();                      
                    })
                    
                    $(".popover").on("mouseleave", function (ev) {
                        console.log("mouseLeave timeout hide..");
                        $(".popover").popover("hide");                    
                    });
                    $element.popover("toggle")
                });
            
            $element.on("inserted.bs.popover", function () {
                var container = $(".popover")[0];

                if (templateName) {

                    ko.renderTemplate(templateName, viewModel, { templateEngine: templateEngine }, container);
                }
                else {
                    container.innerHTML = $element.attr("data-content");
                }
            });

            ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
                $element.popover("dispose");
            });
        }
    };
}

